import { Component } from '@theme/component';

/**
 * Small pill showing the MOQ (minimum order quantity) of whichever printing
 * method is currently selected. Stays in sync with product-printing-method's
 * radio inputs via a plain document-level 'change' listener, since the two
 * components don't share a parent custom element.
 * @extends {Component}
 */
class ProductMoqBadge extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.#abortController;
    document.addEventListener('change', this.#handleChange, { signal });
    this.#syncFromCheckedInput();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /** @param {Event} event */
  #handleChange = (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.name !== 'properties[Printing Method]') return;
    this.#setMoq(target.dataset.moq);
  };

  #syncFromCheckedInput() {
    const checked = document.querySelector('input[name="properties[Printing Method]"]:checked');
    if (checked instanceof HTMLInputElement) this.#setMoq(checked.dataset.moq);
  }

  /** @param {string | undefined} moq */
  #setMoq(moq) {
    if (!moq || !this.refs.value) return;
    this.refs.value.textContent = `${moq} PCS`;
  }
}

if (!customElements.get('product-moq-badge-component')) {
  customElements.define('product-moq-badge-component', ProductMoqBadge);
}
